const getters = {
  isSuperAdmin: state => state.companyID === 0,
  isAuthenticated: state => !!state.username,
  companyID: state => state.companyID,
  username: state => state.username,
  userFullname: state => state.userFullname,
  userTitle: state => state.userTitle,
  token: state => state.token,
  permissions: state => state.permissions || {},
  isPermissionsLoaded: state => state.isPermissionsLoaded,
  passwordChangeToken: state => state.passwordChangeToken,
  mustChangePassword: state => !!state.passwordChangeToken,

  hasAccess: (state) => (resourceCode, actionCode) => {
    if (state.companyID === 0)
      return true
    if (state.permissions === null)
      return false
    if (state.permissions && Object.keys(state.permissions).length === 0)
      return false
    if (!resourceCode)
      return false

    const permission = state.permissions[resourceCode]
    if (!permission)
      return false
    return Array.isArray(permission.actions) && permission.actions.includes(actionCode)
  }
}

export default getters
